import React, { Component } from 'react';
import Select from 'react-select';
import { Button, Col, Collapse, FormGroup, Input, Modal, ModalHeader, ModalBody, Row } from 'reactstrap';
import Api from '../../Api';
import Help from '../../HtmlHelpers';
import AuditLogs from '../../AuditLogs';
import CaretToggle from '../../Icons/CaretToggle';
import AlertErrors from '../../Layout/AlertErrors';
import WmForm from '../../Layout/WmForm';
import WmCreatableSelect from '../../Layout/WmCreatableSelect';
import WmDateField from '../../Layout/WmDateField';
import WmReactTable from '../../Layout/WmReactTable';
import WmTextField from '../../Layout/WmTextField';
import WmToggleField from '../../Layout/WmToggleField';
import WmToggleRadioField from '../../Layout/WmToggleRadioField';
export default class Forms extends Component {
  constructor(props) {
    var _this;
    const item = props.data ? props.data[props.editItem] || {} : {};
    super(props);
    _this = this;
    this.getIncludes = () => this.state.includes;
    this.getItem = () => (this.props.staticItem ? this.props.staticItem : this.state.item) || {};
    this.getAuditLogs = () => this.state.auditLogs;
    this.getApiVersion = () => 1;
    this.options = {};
    // Used for the dropdown fields.
    this.showMeta = meta => '';
    this.setModalStatus = (tag, status) => this.setState({
      [tag]: status
    });
    this.additionalValidations = () => [];
    this.getCrudType = () => '';
    this.formType = () => this.props.t("".concat(this.translationBase(), ".modelType"));
    this.getLabelColumns = () => 4;
    this.getFieldColumns = () => 5;
    this.getModalSize = () => 'lg';
    this.getModalClassName = () => '';
    this.getItemFromApi = function (type, uuid) {
      let version = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      Api.crudView(_this.props.auth, type, uuid, version).then(response => {
        if (response.data !== undefined) {
          _this.setState({
            item: response.data.attributes
          });
        }
        if (response.included !== undefined) {
          const logs = [];
          const includes = {};
          response.included.forEach(d => {
            if (d.type === 'audit-logs') {
              logs.push(d.attributes);
            } else {
              const uuid2 = d.attributes.uuid;
              if (includes[d.type]) {
                includes[d.type][uuid2] = d.attributes;
              } else {
                includes[d.type] = {
                  [uuid2]: d.attributes
                };
              }
            }
          });
          _this.setState({
            auditLogs: logs,
            includes
          });
        }
      });
    };
    this.onChangeRegularEvent = event => {
      const newData = Object.assign({}, this.state.item);
      const target = event.target;
      let value = Help.dig([target, 'value', 'value']) || target.value;
      if (target.type === 'checkbox') {
        value = Help.isEmpty(newData[target.name]) ? value : '';
      }
      if (value === null) {
        value = '';
      }
      newData[target.name] = value;
      return newData;
    };
    this.onChangeFileEvent = async event => {
      const newData = Object.assign({}, this.state.item);
      const target = event.target;
      let value = Help.dig([target, 'value', 'value']) || target.value;
      value = await this.convertImage(target);
      if (value === null) {
        value = '';
      }
      newData[target.name] = value;
      return newData;
    };
    this.onChangeSelectivityEvent = event => {
      const newData = Object.assign({}, this.state.item);
      const name = event.fieldName;
      let value = event.id;
      if (value === null) {
        value = '';
      }
      newData[name] = value;
      return newData;
    };
    this.onChange = event => {
      const newData = event.type === 'selectivity-selected' ? this.onChangeSelectivityEvent(event) : this.onChangeRegularEvent(event);
      this.setVariables({
        item: newData
      });
    };
    this.onFileChange = async event => {
      const newData = await this.onChangeFileEvent(event);
      this.setVariables({
        item: newData
      });
    };
    this.convertImage = target => {
      const reader = new FileReader();
      return new Promise(resolve => {
        reader.onload = () => resolve(reader.result.slice(22));
        reader.readAsDataURL(target.files[0]);
      });
    };
    this.setVariables = stateData => this.setState(stateData);
    this.buildApiVariables = () => this.state.item;
    this.successAlertMsg = data => [undefined, 'success'];
    this.defaultSuccessMsg = () => this.successMsg(this.props.t("".concat(this.translationBase(), ".modelType")));
    // TODO: Translate Line 167
    this.successMsg = type => ["".concat(type, " ").concat(this.isNew() ? 'created' : 'updated', " successfully"), 'success'];
    this.showAlertMsg = info => {
      const [msg, type] = info;
      if (msg !== undefined) {
        this.props.alert.show(msg, {
          type
        });
      }
    };
    this.handleSuccess = data => {
      this.showAlertMsg(this.successAlertMsg(data));
      if (this.props.updateData) {
        this.props.updateData(data);
      } else if (this.updateData) {
        this.updateData(data);
      }
    };
    this.handleResponse = function (response) {
      let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      let errMsgs = [];
      if (response.data !== undefined) {
        _this.handleSuccess(response.data, options);
      } else if (response.meta !== undefined) {
        _this.showMeta(response.meta, options);
      } else if (response.errors !== undefined) {
        errMsgs = errMsgs.concat(Help.convertRailsErrors(response.errors));
      } else {
        // TODO: Translation
        errMsgs.push('System error, please try again. If you continue to get this error, open a Help Desk ticket');
      }
      if (errMsgs.length > 0) {
        _this.setVariables({
          errors: errMsgs,
          disabled: false
        });
      }
    };
    this.onSubmit = event => {
      this.setVariables({
        errors: [],
        disabled: true
      });
      if (Help.validateForm(event.formEl) && this.additionalValidations().length === 0) {
        const apiLink = Help.isEmpty(this.state.item.id) ? 'crudCreate' : 'crudUpdate';
        const type = this.getCrudType();
        Api[apiLink](this.props.auth, type, this.buildApiVariables(), this.getApiVersion()).then(async response => this.handleResponse(response));
      } else {
        this.setVariables({
          disabled: false
        });
      }
    };
    this.formData = () => new FormData();
    this.formDataSubmit = event => {
      this.setVariables({
        errors: [],
        disabled: true
      });

      // TODO: Change env variable name
      const ottoApiHost = Api.localStorageHost() || process.env.REACT_APP_CONTRACTO_API_URL;
      const url = "".concat(ottoApiHost, "/v1/").concat(this.getCrudType());
      if (Help.validateForm(event.formEl) && this.additionalValidations().length === 0) {
        Api.doRequest('POST', url, this.formData(), this.props.auth).then(async response => this.handleResponse(response));
      } else {
        this.setVariables({
          disabled: false
        });
      }
    };
    // TODO: Translation Line 236
    this.getButton = function (type) {
      let onClick = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      return /*#__PURE__*/React.createElement(Button, {
        outline: true,
        className: "btn-sm",
        color: "info",
        onClick: onClick,
        disabled: type === 'Cancel' ? false : _this.state.disabled
      }, type);
    };
    this.inRow = content => /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      md: "12",
      xs: "12"
    }, content));
    this.getRow = (field, label) => this.getRowWithValue(label, this.getItem()[field]);
    this.getRowWithValue = (label, value) => /*#__PURE__*/React.createElement(Row, null, Help.getWmLabel({
      labelColumns: 4,
      text: label
    }), /*#__PURE__*/React.createElement(Col, {
      md: 8
    }, value));
    this.getTextRow = function (label, value) {
      let className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'otto__label text-right';
      return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
        md: _this.getLabelColumns(),
        xs: _this.getLabelColumns(),
        className: className
      }, label), /*#__PURE__*/React.createElement(Col, {
        md: _this.getFieldColumns(),
        xs: 12 - parseInt(_this.getLabelColumns(), 10)
      }, value));
    };
    this.getToggleRadioField = function (field1, field2, fieldName, label) {
      let required = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
      let readOnly = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
      let options = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
      return _this.inRow( /*#__PURE__*/React.createElement(WmToggleRadioField, {
        labelColumns: options.labelColumns || _this.getLabelColumns(),
        fieldColumns: options.fieldColumns || _this.getFieldColumns(),
        text: label,
        htmlFor: fieldName,
        name: fieldName,
        field1: field1,
        field2: field2,
        value: options.value || _this.state.item[fieldName],
        onChange: _this.onChange,
        isRequired: required,
        readOnly: readOnly
      }));
    };
    this.getTextFieldRow = function (fieldName, label) {
      let required = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      return _this.inRow( /*#__PURE__*/React.createElement(WmTextField, {
        fieldType: "text",
        labelColumns: options.labelColumns || _this.getLabelColumns(),
        fieldColumns: options.fieldColumns || _this.getFieldColumns(),
        text: label,
        htmlFor: fieldName,
        name: fieldName,
        value: options.value || _this.state.item[fieldName] || '',
        onChange: _this.onChange,
        isRequired: required,
        inputGroup: options.inputGroup,
        autoComplete: options.autoComplete,
        maxLength: options.maxLength,
        minLength: options.minLength,
        buttonAfter: options.buttonAfter
      }));
    };
    this.getDisplayFieldRow = function (fieldName, label, value) {
      let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      return _this.inRow( /*#__PURE__*/React.createElement(WmTextField, {
        fieldType: "text",
        labelColumns: options.labelColumns || _this.getLabelColumns(),
        fieldColumns: options.fieldColumns || _this.getFieldColumns(),
        text: label,
        htmlFor: fieldName,
        name: fieldName,
        value: value || '',
        inputGroup: options.inputGroup,
        readOnly: true,
        buttonAfter: options.buttonAfter
      }));
    };
    this.getNumericFieldRow = function (fieldName, label) {
      let required = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      return _this.inRow( /*#__PURE__*/React.createElement(WmTextField, {
        fieldType: "number",
        labelColumns: options.labelColumns || _this.getLabelColumns(),
        fieldColumns: options.fieldColumns || _this.getFieldColumns(),
        text: label,
        htmlFor: fieldName,
        name: fieldName,
        value: options.value || _this.state.item[fieldName] || '',
        onChange: _this.onChange,
        isRequired: required,
        min: options.min,
        max: options.max,
        step: options.step,
        inputGroup: options.inputGroup,
        buttonAfter: options.buttonAfter
      }));
    };
    this.getDateFieldRow = function (fieldName, label) {
      let required = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      return _this.inRow( /*#__PURE__*/React.createElement(WmDateField, {
        labelColumns: options.labelColumns || _this.getLabelColumns(),
        fieldColumns: options.fieldColumns || _this.getFieldColumns(),
        text: label,
        htmlFor: fieldName,
        name: fieldName,
        value: options.value || _this.state.item[fieldName] || '',
        onChange: _this.onChange,
        isRequired: required
      }));
    };
    this.getDateTimeFieldRow = function (fieldName, label) {
      let required = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      const labelInfo = {
        text: label,
        htmlFor: fieldName,
        labelColumns: _this.getLabelColumns()
      };
      return _this.inRow( /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Row, {
        className: "align-items-center"
      }, Help.getWmLabel(labelInfo), /*#__PURE__*/React.createElement(Col, {
        md: _this.getFieldColumns(),
        className: "text-left"
      }, /*#__PURE__*/React.createElement(Input, {
        type: "datetime-local",
        className: "form-control",
        text: label,
        htmlFor: fieldName,
        name: fieldName,
        value: options.value || _this.state.item[fieldName],
        onChange: _this.onChange,
        required: required
      })))));
    };
    this.getHour15Min = function (fieldName, label) {
      let required = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      const labelInfo = {
        text: label,
        htmlFor: fieldName,
        labelColumns: _this.getLabelColumns()
      };
      const hours = [...Array(24).keys()].map(idx => {
        const num = idx.toString().padStart(2, '0');
        return {
          label: num,
          value: num
        };
      });
      const minutes = [{
        label: '00',
        value: '00'
      }, {
        label: '15',
        value: '15'
      }, {
        label: '30',
        value: '30'
      }, {
        label: '45',
        value: '45'
      }];
      const dropdownOnChange = (field, selected) => {
        const value = {
          target: {
            name: field,
            value: selected
          }
        };
        _this.onChange(value);
      };
      return _this.inRow( /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Row, {
        className: "align-items-center"
      }, Help.getWmLabel(labelInfo), /*#__PURE__*/React.createElement(Col, {
        md: 2,
        className: "text-left"
      }, /*#__PURE__*/React.createElement(Select, {
        required: options.isRequired || true,
        name: "".concat(fieldName, "_hour"),
        onChange: data => dropdownOnChange("".concat(fieldName, "_hour"), data),
        options: hours,
        placeholder: "Hour",
        className: "text-left"
      })), /*#__PURE__*/React.createElement(Col, {
        md: 2,
        className: "text-left"
      }, /*#__PURE__*/React.createElement(Select, {
        required: options.isRequired || true,
        name: "".concat(fieldName, "_minutes"),
        onChange: data => dropdownOnChange("".concat(fieldName, "_minutes"), data),
        options: minutes,
        placeholder: "Minutes",
        className: "text-left"
      })))));
    };
    this.getCreatableFieldRow = options => this.inRow( /*#__PURE__*/React.createElement(WmCreatableSelect, {
      apiLink: options.api,
      apiParams: options.apiParams,
      labelColumns: options.labelColumns || this.getLabelColumns(),
      fieldColumns: options.fieldColumns || this.getFieldColumns(),
      labelField: options.labelField,
      valueField: options.valueField,
      text: options.label,
      htmlFor: options.field,
      name: options.field,
      selected: options.value,
      onChange: this.onChange
    }));
    this.getUploadFileRow = function (fieldName, label) {
      let required = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      const uploadLabel = {
        text: label,
        htmlFor: fieldName,
        labelColumns: _this.getLabelColumns()
      };
      return _this.inRow( /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Row, {
        className: "align-items-center"
      }, Help.getWmLabel(uploadLabel), /*#__PURE__*/React.createElement(Col, {
        md: _this.getFieldColumns(),
        xs: 12 - parseInt(_this.getLabelColumns(), 10)
      }, /*#__PURE__*/React.createElement(Input, {
        type: "file",
        name: fieldName,
        id: fieldName,
        required: required,
        onChange: _this.onFileChange
      }), /*#__PURE__*/React.createElement("div", {
        className: "invalid-feedback"
      })))));
    };
    this.getTextareaRowSize = () => 3;
    this.getTextareaRow = function (fieldName, label) {
      let required = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      let value = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      const uploadLabel = {
        text: label,
        htmlFor: fieldName,
        labelColumns: _this.getLabelColumns()
      };
      return _this.inRow( /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Row, {
        className: "align-items-center"
      }, Help.getWmLabel(uploadLabel), /*#__PURE__*/React.createElement(Col, {
        md: _this.getFieldColumns(),
        xs: 12 - parseInt(_this.getLabelColumns(), 10)
      }, /*#__PURE__*/React.createElement(Input, {
        type: "textarea",
        className: "form-control",
        name: fieldName,
        value: value || _this.state.item[fieldName] || '',
        onChange: _this.onChange,
        required: required,
        rows: _this.getTextareaRowSize()
      }), /*#__PURE__*/React.createElement("div", {
        className: "invalid-feedback"
      })))));
    };
    this.getImageRow = function (img) {
      let width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 150;
      let afterButton = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      let content = '';
      if (Help.isNotEmpty(img)) {
        content = /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Row, {
          className: "align-items-center"
        }, /*#__PURE__*/React.createElement(Col, {
          md: _this.getLabelColumns(),
          xs: _this.getLabelColumns()
        }), /*#__PURE__*/React.createElement(Col, {
          md: _this.getFieldColumns(),
          xs: 12 - parseInt(_this.getLabelColumns(), 10)
        }, /*#__PURE__*/React.createElement("img", {
          width: width,
          src: "data:image/png;base64,".concat(img),
          alt: ""
        }), afterButton)));
      }
      return content;
    };
    this.uuidValue = field => {
      const uuid = this.state.item[field];
      let value = this.state.item[field];
      if (uuid && uuid.value) {
        value = uuid.value;
      }
      return value;
    };
    this.dropdownField = function (type) {
      let optionsParam = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      const option = _this.options(optionsParam)[type];
      const additonalProps = option.props || {};
      const TagName = option.component;
      return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
        md: "12"
      }, /*#__PURE__*/React.createElement(TagName, Object.assign({}, additonalProps, {
        auth: option.auth || _this.props.auth,
        labelColumns: option.labelColumns || _this.getLabelColumns(),
        fieldColumns: option.fieldColumns || _this.getFieldColumns(),
        fieldLabel: option.label,
        fieldName: option.field,
        onChange: _this.onChange,
        addBlank: true,
        multi: option.multiple,
        disabled: option.disabled,
        data: option.data,
        buttonAfter: option.buttonAfter,
        query: option.query,
        currentValue: option.currentValue || _this.uuidValue(option.field),
        current_value: _this.uuidValue(option.field),
        value: _this.uuidValue(option.field),
        defaultData: option.defaultData
      }))));
    };
    // TODO: Translate Lines 510, 511
    this.yesNoField = function (field, label) {
      let required = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      let readOnly = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      let value = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      return _this.getToggleRadioField({
        label: 'Yes',
        value: 'true'
      }, {
        label: 'No',
        value: 'false'
      }, field, label, required, readOnly, {
        value
      });
    };
    // TODO: Translate
    this.activeField = () => this.yesNoField('active', 'Active');
    // TODO: Translate
    this.activeInactiveDisplay = (label, text) => ['Inactive', 'No'].includes(text) ? this.boldRed(label, text) : this.getRowWithValue(label, text);
    this.boldRed = (label, text) => this.getRowWithValue(label, /*#__PURE__*/React.createElement("div", {
      style: {
        color: 'red',
        fontWeight: 'bold'
      }
    }, text));
    this.isNew = () => Help.isEmpty(this.state.item.uuid);
    // TODO: Translate Line 542
    this.submitButtons = () => this.props.type === 'view' ? '' : /*#__PURE__*/React.createElement("div", {
      className: "text-center"
    }, this.getButton(this.submitLabel()), "\xA0\xA0\xA0", this.getButton('Cancel', this.closeModal));
    this.submitLabel = () => {
      // TODO: Translate
      const prefix = this.isNew() ? 'Create ' : 'Update ';
      return "".concat(prefix, " ").concat(this.formType());
    };
    this.toggleAudit = () => this.setState(prevState => ({
      auditLogOpen: !prevState.auditLogOpen
    }));
    this.auditLogs = () => {
      let content = '';
      if (this.state.item.uuid !== undefined) {
        const open = this.state.auditLogOpen;
        // TODO: Translate Line 564
        content = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("h4", null, "Audit Logs (", this.getAuditLogs().length, ") \xA0\xA0\xA0", /*#__PURE__*/React.createElement(CaretToggle, {
          onClick: this.toggleAudit,
          open: open
        })), /*#__PURE__*/React.createElement(Collapse, {
          isOpen: this.state.auditLogOpen
        }, /*#__PURE__*/React.createElement(WmReactTable, {
          data: this.getAuditLogs(),
          columns: AuditLogs(this),
          sortBy: [{
            id: 'id',
            desc: true
          }]
        })));
      }
      return content;
    };
    // TODO: Translate Lines 586, 588
    this.headerTitle = () => {
      let title = 'View';
      if (this.props.type !== 'view') {
        title = this.isNew() ? 'Add ' : 'Edit ';
      }
      return title;
    };
    this.getContents = () => this.props.type === 'view' ? this.viewPage() : this.modalPage();
    this.showButtonsAndErrors = () => true;
    this.buttonsAndErrors = () => /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      md: "12",
      xs: "12",
      className: "text-center"
    }, /*#__PURE__*/React.createElement(AlertErrors, {
      errors: this.state.errors
    }), this.submitButtons()));
    this.closeModal = () => this.props.closeModal();
    this.underButtons = () => '';
    this.modalPage = () => /*#__PURE__*/React.createElement(Modal, {
      className: this.getModalClassName(),
      size: this.getModalSize(),
      isOpen: this.props.showModal,
      toggle: this.closeModal,
      backdrop: "static"
    }, /*#__PURE__*/React.createElement(ModalHeader, {
      toggle: this.closeModal
    }, this.headerTitle(), this.formType()), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(WmForm, {
      submit: this.onSubmit,
      ref: this.formRef,
      id: "form__crud"
    }, this.modalBodyRows(), this.showButtonsAndErrors() ? this.buttonsAndErrors() : '', this.underButtons())));
    this.viewPage = () => /*#__PURE__*/React.createElement("div", null, this.modalBodyRows(), this.auditLogs());
    this.state = {
      item,
      includes: props.includes || {},
      auditLogs: props.auditLogs || [],
      disabled: false,
      errors: [],
      auditLogOpen: false
    };
    this.formRef = React.createRef();
  }
  render() {
    return this.getContents();
  }
}